import React from 'react';
import ReactDOM from 'react-dom'
import Loader from "./loading";

export interface loaderConfig {
    content?: string
}

function createLoader(callback: (i: any) => void) {
    const div = document.createElement('div');
    document.body.appendChild(div);

    let called = false;

    function ref(load: Loader) {
        if (called) {
            return;
        }
        called = true;
        callback({
            show(config: loaderConfig) {
                load.showLoading(config);
            },
            close() {
                load.hideLoading();
            },
            component: load,
            destroy() {
                ReactDOM.unmountComponentAtNode(div);
                if (div.parentNode) {
                    div.parentNode.removeChild(div);
                }
            },
        });
    }

    ReactDOM.render(<Loader ref={ref}/>, div);
}

let loaderInstance: any;
let openTime: Date;

function getLoaderInstance(callback: (i: any) => void) {
    if (loaderInstance) {
        callback(loaderInstance);
        return;
    }
    createLoader((instance: any) => {
        if (loaderInstance) {
            callback(loaderInstance)
            return
        }
        loaderInstance = instance
        callback(instance)
    })
}

export interface loaderType {
    (): void,
}
let timeout: number;

function loader(config: loaderConfig): void {
    if(!openTime){
        openTime = new Date()
    }
    getLoaderInstance(instance => {
        instance.show(config);
    });

    const result: any = () => {
        if (loaderInstance) {
            if(timeout){
                clearTimeout(timeout)
                timeout = 0;
            }
            timeout = window.setTimeout(()=> {
                loaderInstance.close();
            }, 500)
        }
    };

    return result;
}

const api: any = {
    open: loader,
    destroy() {
        if (loaderInstance) {
            loaderInstance.destroy();
            loaderInstance = null;
        }
    }
}

export interface LoaderApi {
    open(config: loaderConfig): loaderType,

    destroy(): void
}

export default api as LoaderApi
